import {
    Component,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { UserGroup } from '@intranet/modules/users';

@Component({
    selector: 'admin-group-table',
    templateUrl: './group-table.component.html',
    styleUrls: ['./group-table.component.scss'],
})
export class AdminGroupTableComponent {
    @Output() selected = new EventEmitter<UserGroup>();

    private _groups: UserGroup[] = [];

    @Input() set groups(value: UserGroup[]) {
        this._groups = Array.isArray(value) ? [...value] : [];
        this.sortGroups();
    }

    get groups(): UserGroup[] {
        return this._groups;
    }

    sortBy: string = 'groupName';
    sortDir: 'asc' | 'desc' = 'asc';

    onSort(column: string) {
        if (this.sortBy === column) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortDir = 'asc';
        }

        this.sortGroups();
    }

    sortGroups() {
        this._groups = [...this._groups].sort((a, b) => {
            let valueA: any;
            let valueB: any;

            if (this.sortBy === 'groupName') {
                valueA = a.groupName.toLowerCase();
                valueB = b.groupName.toLowerCase();
            } else if (this.sortBy === 'totalUsers') {
                valueA = a.totalUsers;
                valueB = b.totalUsers;
            }

            return this.sortDir === 'asc' ? (valueA > valueB ? 1 : -1) : (valueA < valueB ? 1 : -1);
        });
    }

    onSelect(group: UserGroup) {
        this.selected.emit(group);
    }
}